import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { FC, useCallback } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";

export const S_SETTINGS_POPUP = new Signal<boolean>("S_SETTINGS_POPUP");

export const SettingsPopup: FC = () => {
	useLocale();
	const show = S_SETTINGS_POPUP.use();
	const [project] = GD.B_SELECTED_PROJECT.use();

	const closePopup = useCallback(() => {
		S_SETTINGS_POPUP.invoke(false);
	}, []);

	if (!show) return null;

	return (
		<Panel sx={{ minWidth: "600px", maxWidth: "800px", height: "85vh", backgroundColor: "#eeeeee" }} decorator="absolute" label={msg("settings")} onClose={closePopup}>
			<Box sx={{ height: "100%", overflow: "auto" }}>
				{project && (
					<FormParser
						onSubmit={async (data: unknown): Promise<any> => {
							return await GD.REQ_API.request({
								method: "settings/set",
								data: data,
							});
						}}
						onRequest={async (): Promise<unknown> => {
							return GD.REQ_API.request({
								method: "settings/get",
								data: {
									target_type: "project",
									target_id: project.id,
									type: "project_settings",
								},
							});
						}}
					/>
				)}
			</Box>
		</Panel>
	);
};
